import { render, staticRenderFns } from "./InquiryComponent.vue?vue&type=template&id=cceff7e6&scoped=true&"
import script from "./InquiryComponent.vue?vue&type=script&lang=js&"
export * from "./InquiryComponent.vue?vue&type=script&lang=js&"
import style0 from "./InquiryComponent.vue?vue&type=style&index=0&id=cceff7e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cceff7e6",
  null
  
)

export default component.exports